// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__3Ut5U","selects":"Documents_selects__3xcuN"};